// src/constants/tutorialSteps.ts

export const TUTORIAL_STEPS = [
  {
    title: "🐱 Pip Finds You",
    content: `Hello there! I'm Pip, and I've been searching for someone like you. *adjusts witch hat nervously*

I used to help care for a magical sanctuary hidden deep in the forest - a place where 50 unique species of creatures lived in harmony. Each one had their own special habitat, designed just for them.

But... that was a long time ago. The sanctuary has been abandoned for years, and all the creatures have scattered into the wild. I've tried to find them myself, but cats can only do so much with paws, you know? 🐾

Will you help me restore the sanctuary and bring all our lost friends home?`
  },
  {
    title: "🌿 The Abandoned Sanctuary",
    content: `*leads you through overgrown paths to a clearing*

Here it is... or what's left of it. The habitats are damaged, the paths are overgrown, and not a single creature remains. It breaks my heart to see it like this.

*pulls out an old, dusty journal from under his hat*

I saved this - the old compatibility charts and field notes from when the sanctuary was thriving. Between your hands and my knowledge, we can rebuild this place together!

Our mission: Find every creature species that once lived here and convince them to come home. Are you ready to be my partner in this?`
  },
  {
    title: "🎯 Choose Your First Friend",
    content: `*sits down and washes face thoughtfully*

Before we begin, you'll need to choose your very first creature companion. This is important! I've managed to befriend a few species who trust me, and I can introduce you to one of them.

Different creatures have different elemental types, and here's the secret: wild creatures will only trust you if you bring a compatible species along to vouch for you. It's like a letter of recommendation, but fluffier!

*purrs encouragingly*

Pick the one that feels right to you. They'll be your partner as we search for their lost friends.`
  },
  {
    title: "🏠 Habitat Harmony",
    content: `*jumps onto a habitat wall and peers down*

Each habitat can hold several creatures, but placement is everything! You see, creatures with compatible elemental types will be happier together, while incompatible types might get stressed.

*demonstrates by pawing at imaginary creatures*

You can drag and drop them between habitats - I'd do it myself, but these paws aren't built for precision work. Happy creatures have green faces (😊), neutral ones are yellow (😐), and unhappy ones turn red (😞).

Keep everyone content, and they'll thrive! A happy sanctuary is a successful sanctuary.`
  },
  {
    title: "🗺️ Exploring Together",
    content: `*tail swishes with excitement*

Now for the fun part - exploration! I know all the territories where creatures hide: meadows, forests, mountains, even mysterious caves.

But here's the thing: you can only bring ONE companion with you on each expedition. Their elemental type determines which wild creatures might be willing to join us.

*taps field journal with paw*

I'll guide you to each territory, but you need to choose your companion wisely. Type compatibility is the key to success! Some expeditions might need a Fire type, others might need Water... strategy is important!`
  },
  {
    title: "📖 The Journey Ahead",
    content: `*settles down and looks at you warmly*

I'll keep track of everything in this field journal - every creature you encounter, every species you discover. Even if they don't join us the first time, we'll remember them.

Some creatures have dual types, which makes them incredibly valuable for attracting multiple species! They're also trickier to keep happy, but worth the effort.

*stands up and stretches*

As we find more species, new territories and habitats will unlock. Rarer creatures hide in those places! The compatibility charts in this journal will guide you.

Our goal: Find all 50 lost species and bring them home. Not just discover them - we need to convince every single one to return to the sanctuary.

*adjusts witch hat with determination*

Ready to restore the sanctuary with me? Let's bring our friends home! 🐾`
  }
];